import { query } from '@confluence/query-preloader-tools';

import { GetLicensedProductsQuery } from './GetLicensedProducts.graphql';

export const preloadGetLicensedProductsQuery = () => {
	return query({
		query: GetLicensedProductsQuery,
	});
};
